export default __webpack_public_path__ + "static/media/equal-opportunities-monitoring-form.1f0d40b4.pdf";